import img from "./Images/card1/hero.png";
import img2 from "./Images/card1/firstCardImg.gif";
import img21 from "./Images/card1/CWTA.webp";
import img22 from "./Images/card1/Flow.png";
import img23 from "./Images/card1/Payment.webp";
import img24 from "./Images/card1/Template.webp";

// import img1 from "../img/Flow.png";
// import img2 from "../img/Payment.webp";
// import img3 from "../img/Template.webp";
// import img4 from "../img/Webview.png";

const data = [
  {
    card_id: "1",
    introduction: {
      img: img,
      title:
        "rojaline Unlock digital success for your business with all-in-one SaaS solution!",
      description:
        "Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite.",
    },

    features: [
      {
        img: img2,
        title: "Test Feature 1",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },
      {
        img: img2,
        title: "Feature 2",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },

      {
        img: img2,
        title: "Feature 3",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },

      {
        img: img2,
        title: "Feature 4",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },
    ],

    use_case: [
      {
        img: img,
        title: "Run Ads that Click to WhatsApp1",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },
      {
        img: img,
        title: "Run Ads that Click to WhatsApp2",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },

      {
        img: img,
        title: "Run Ads that Click to WhatsApp3",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },

      {
        img: img,
        title: "Run Ads that Click to WhatsApp4",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },
    ],

    marketing: [
      {
        card_title: "Event Registration 11",
        card_description:
          "Automatically register participants via WhatsApp for your events based on chatbot-initiated interactions. ",
        card_img: img21,
        card_background: "#e1efff",
      },
      {
        card_title: "Event Registration 12",
        card_description:
          "Track real-time analytics and registrations using WhatsApp-based campaign systems tailored to your needs.",
        card_img: img22,
        card_background: "#EAFBF1",
      },
      {
        card_title: "Event Registration 13",
        card_description:
          "Gather payments for your event registrations directly via WhatsApp integrated payment gateways.",
        card_img: img23,
        card_background: "#e2e9f0",
      },
      {
        card_title: "Event Registration 14",
        card_description:
          "Send smart reminders and follow-ups to incomplete registrations to boost participation.",
        card_img: img24,
        card_background: "#e3e9ff",
      },
    ],
  },

  {
    card_id: "2",
    introduction: {
      img: img,
      title:
        "2Unlock digital success for your business with all-in-one SaaS solution!",
      description:
        "2Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite.",
    },

    features: [
      {
        img: img2,
        title: "Test Feature 1",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },
      {
        img: img2,
        title: "Feature 2",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },

      {
        img: img2,
        title: "Feature 3",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },

      {
        img: img2,
        title: "Feature 4",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },
    ],

    use_case: [
      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },
      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },

      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },

      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },
    ],

    marketing: [
      {
        img: img,
        title: "Event Registration 1",
        description1:
          "Automatically register participants via WhatsApp for your events based on chatbot-initiated interactions. ",
        background: "#e1efff",
      },
      {
        img: img,
        title: "Event Registration 2",
        description1:
          "Track real-time analytics and registrations using WhatsApp-based campaign systems tailored to your needs.",
        background: "#EAFBF1",
      },

      {
        img: img,
        title: "Event Registration 3",
        description1:
          "Gather payments for your event registrations directly via WhatsApp integrated payment gateways.",
        background: "#e2e9f0",
      },

      {
        img: img,
        title: "Event Registration 4",
        description1:
          "Send smart reminders and follow-ups to incomplete registrations to boost participation.",
        background: "#e3e9ff",
      },
    ],
  },

  {
    card_id: "3",
    introduction: {
      img: img,
      title:
        "3Unlock digital success for your business with all-in-one SaaS solution!",
      description:
        "3Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite.",
    },

    features: [
      {
        img: img2,
        title: "Test Feature 1",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },
      {
        img: img2,
        title: "Feature 2",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },

      {
        img: img2,
        title: "Feature 3",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },

      {
        img: img2,
        title: "Feature 4",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },
    ],

    use_case: [
      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },
      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },

      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },

      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },
    ],

    marketing: [
      {
        img: img,
        title: "Event Registration 1",
        description1:
          "Automatically register participants via WhatsApp for your events based on chatbot-initiated interactions. ",
        background: "#e1efff",
      },
      {
        img: img,
        title: "Event Registration 2",
        description1:
          "Track real-time analytics and registrations using WhatsApp-based campaign systems tailored to your needs.",
        background: "#EAFBF1",
      },

      {
        img: img,
        title: "Event Registration 3",
        description1:
          "Gather payments for your event registrations directly via WhatsApp integrated payment gateways.",
        background: "#e2e9f0",
      },

      {
        img: img,
        title: "Event Registration 4",
        description1:
          "Send smart reminders and follow-ups to incomplete registrations to boost participation.",
        background: "#e3e9ff",
      },
    ],
  },

  {
    card_id: "4",
    introduction: {
      img: img,
      title:
        "4Unlock digital success for your business with all-in-one SaaS solution!",
      description:
        "4Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite.",
    },

    features: [
      {
        img: img2,
        title: "Test Feature 1",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },
      {
        img: img2,
        title: "Feature 2",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },

      {
        img: img2,
        title: "Feature 3",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },

      {
        img: img2,
        title: "Feature 4",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },
    ],

    use_case: [
      {
        img: img,
        title: "Run Ads that Click to WhatsApp1",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },
      {
        img: img,
        title: "Run Ads that Click to WhatsApp2",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },

      {
        img: img,
        title: "Run Ads that Click to WhatsApp3",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },

      {
        img: img,
        title: "Run Ads that Click to WhatsApp4",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },
    ],

    marketing: [
      {
        card_title: "Event Registration 11",
        card_description:
          "Automatically register participants via WhatsApp for your events based on chatbot-initiated interactions. ",
        card_img: img21,
        card_background: "#e1efff",
      },
      {
        card_title: "Event Registration 12",
        card_description:
          "Track real-time analytics and registrations using WhatsApp-based campaign systems tailored to your needs.",
        card_img: img22,
        card_background: "#EAFBF1",
      },
      {
        card_title: "Event Registration 13",
        card_description:
          "Gather payments for your event registrations directly via WhatsApp integrated payment gateways.",
        card_img: img23,
        card_background: "#e2e9f0",
      },
      {
        card_title: "Event Registration 14",
        card_description:
          "Send smart reminders and follow-ups to incomplete registrations to boost participation.",
        card_img: img24,
        card_background: "#e3e9ff",
      },
    ],
  },

  {
    card_id: "5",
    introduction: {
      img: img,
      title:
        "5Unlock digital success for your business with all-in-one SaaS solution!",
      description:
        "5Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite.",
    },

    features: [
      {
        img: img2,
        title: "Test Feature 1",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },
      {
        img: img2,
        title: "Feature 2",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },

      {
        img: img2,
        title: "Feature 3",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },

      {
        img: img2,
        title: "Feature 4",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },
    ],

    use_case: [
      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },
      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },

      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },

      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },
    ],

    marketing: [
      {
        img: img,
        title: "Event Registration 1",
        description1:
          "Automatically register participants via WhatsApp for your events based on chatbot-initiated interactions. ",
        background: "#e1efff",
      },
      {
        img: img,
        title: "Event Registration 2",
        description1:
          "Track real-time analytics and registrations using WhatsApp-based campaign systems tailored to your needs.",
        background: "#EAFBF1",
      },

      {
        img: img,
        title: "Event Registration 3",
        description1:
          "Gather payments for your event registrations directly via WhatsApp integrated payment gateways.",
        background: "#e2e9f0",
      },

      {
        img: img,
        title: "Event Registration 4",
        description1:
          "Send smart reminders and follow-ups to incomplete registrations to boost participation.",
        background: "#e3e9ff",
      },
    ],
  },

  {
    card_id: "6",
    introduction: {
      img: img,
      title:
        "6Unlock digital success for your business with all-in-one SaaS solution!",
      description:
        "6Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite.",
    },

    features: [
      {
        img: img2,
        title: "Test Feature 1",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },
      {
        img: img2,
        title: "Feature 2",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },

      {
        img: img2,
        title: "Feature 3",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },

      {
        img: img2,
        title: "Feature 4",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },
    ],

    use_case: [
      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },
      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },

      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },

      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },
    ],

    marketing: [
      {
        img: img,
        title: "Event Registration 1",
        description1:
          "Automatically register participants via WhatsApp for your events based on chatbot-initiated interactions. ",
        background: "#e1efff",
      },
      {
        img: img,
        title: "Event Registration 2",
        description1:
          "Track real-time analytics and registrations using WhatsApp-based campaign systems tailored to your needs.",
        background: "#EAFBF1",
      },

      {
        img: img,
        title: "Event Registration 3",
        description1:
          "Gather payments for your event registrations directly via WhatsApp integrated payment gateways.",
        background: "#e2e9f0",
      },

      {
        img: img,
        title: "Event Registration 4",
        description1:
          "Send smart reminders and follow-ups to incomplete registrations to boost participation.",
        background: "#e3e9ff",
      },
    ],
  },

  {
    card_id: "7",
    introduction: {
      img: img,
      title:
        "7Unlock digital success for your business with all-in-one SaaS solution!",
      description:
        "7Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite.",
    },

    features: [
      {
        img: img2,
        title: "Test Feature 1",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },
      {
        img: img2,
        title: "Feature 2",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },

      {
        img: img2,
        title: "Feature 3",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },

      {
        img: img2,
        title: "Feature 4",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },
    ],

    use_case: [
      {
        img: img,
        title: "Run Ads that Click to WhatsApp1",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },
      {
        img: img,
        title: "Run Ads that Click to WhatsApp2",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },

      {
        img: img,
        title: "Run Ads that Click to WhatsApp3",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },

      {
        img: img,
        title: "Run Ads that Click to WhatsApp4",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },
    ],

    marketing: [
      {
        card_title: "Event Registration 11",
        card_description:
          "Automatically register participants via WhatsApp for your events based on chatbot-initiated interactions. ",
        card_img: img21,
        card_background: "#e1efff",
      },
      {
        card_title: "Event Registration 12",
        card_description:
          "Track real-time analytics and registrations using WhatsApp-based campaign systems tailored to your needs.",
        card_img: img22,
        card_background: "#EAFBF1",
      },
      {
        card_title: "Event Registration 13",
        card_description:
          "Gather payments for your event registrations directly via WhatsApp integrated payment gateways.",
        card_img: img23,
        card_background: "#e2e9f0",
      },
      {
        card_title: "Event Registration 14",
        card_description:
          "Send smart reminders and follow-ups to incomplete registrations to boost participation.",
        card_img: img24,
        card_background: "#e3e9ff",
      },
    ],
  },

  {
    card_id: "8",
    introduction: {
      img: img,
      title:
        "8Unlock digital success for your business with all-in-one SaaS solution!",
      description:
        "8Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite.",
    },

    features: [
      {
        img: img2,
        title: "Test Feature 1",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },
      {
        img: img2,
        title: "Feature 2",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },

      {
        img: img2,
        title: "Feature 3",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },

      {
        img: img2,
        title: "Feature 4",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },
    ],

    use_case: [
      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },
      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },

      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },

      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },
    ],

    marketing: [
      {
        img: img,
        title: "Event Registration 1",
        description1:
          "Automatically register participants via WhatsApp for your events based on chatbot-initiated interactions. ",
        background: "#e1efff",
      },
      {
        img: img,
        title: "Event Registration 2",
        description1:
          "Track real-time analytics and registrations using WhatsApp-based campaign systems tailored to your needs.",
        background: "#EAFBF1",
      },

      {
        img: img,
        title: "Event Registration 3",
        description1:
          "Gather payments for your event registrations directly via WhatsApp integrated payment gateways.",
        background: "#e2e9f0",
      },

      {
        img: img,
        title: "Event Registration 4",
        description1:
          "Send smart reminders and follow-ups to incomplete registrations to boost participation.",
        background: "#e3e9ff",
      },
    ],
  },

  {
    card_id: "9",
    introduction: {
      img: img,
      title:
        "9Unlock digital success for your business with all-in-one SaaS solution!",
      description:
        "9Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite.",
    },

    features: [
      {
        img: img2,
        title: "Test Feature 1",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },
      {
        img: img2,
        title: "Feature 2",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },

      {
        img: img2,
        title: "Feature 3",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },

      {
        img: img2,
        title: "Feature 4",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },
    ],

    use_case: [
      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },
      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },

      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },

      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },
    ],

    marketing: [
      {
        img: img,
        title: "Event Registration 1",
        description1:
          "Automatically register participants via WhatsApp for your events based on chatbot-initiated interactions. ",
        background: "#e1efff",
      },
      {
        img: img,
        title: "Event Registration 2",
        description1:
          "Track real-time analytics and registrations using WhatsApp-based campaign systems tailored to your needs.",
        background: "#EAFBF1",
      },

      {
        img: img,
        title: "Event Registration 3",
        description1:
          "Gather payments for your event registrations directly via WhatsApp integrated payment gateways.",
        background: "#e2e9f0",
      },

      {
        img: img,
        title: "Event Registration 4",
        description1:
          "Send smart reminders and follow-ups to incomplete registrations to boost participation.",
        background: "#e3e9ff",
      },
    ],
  },

  {
    card_id: "10",
    introduction: {
      img: img,
      title:
        "10Unlock digital success for your business with all-in-one SaaS solution!",
      description:
        "10Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite.",
    },

    features: [
      {
        img: img2,
        title: "Test Feature 1",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },
      {
        img: img2,
        title: "Feature 2",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },

      {
        img: img2,
        title: "Feature 3",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },

      {
        img: img2,
        title: "Feature 4",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },
    ],

    use_case: [
      {
        img: img,
        title: "Run Ads that Click to WhatsApp1",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },
      {
        img: img,
        title: "Run Ads that Click to WhatsApp2",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },

      {
        img: img,
        title: "Run Ads that Click to WhatsApp3",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },

      {
        img: img,
        title: "Run Ads that Click to WhatsApp4",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },
    ],

    marketing: [
      {
        card_title: "Event Registration 11",
        card_description:
          "Automatically register participants via WhatsApp for your events based on chatbot-initiated interactions. ",
        card_img: img21,
        card_background: "#e1efff",
      },
      {
        card_title: "Event Registration 12",
        card_description:
          "Track real-time analytics and registrations using WhatsApp-based campaign systems tailored to your needs.",
        card_img: img22,
        card_background: "#EAFBF1",
      },
      {
        card_title: "Event Registration 13",
        card_description:
          "Gather payments for your event registrations directly via WhatsApp integrated payment gateways.",
        card_img: img23,
        card_background: "#e2e9f0",
      },
      {
        card_title: "Event Registration 14",
        card_description:
          "Send smart reminders and follow-ups to incomplete registrations to boost participation.",
        card_img: img24,
        card_background: "#e3e9ff",
      },
    ],
  },

  {
    card_id: "11",
    introduction: {
      img: img,
      title:
        "11Unlock digital success for your business with all-in-one SaaS solution!",
      description:
        "11Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite.",
    },

    features: [
      {
        img: img2,
        title: "Test Feature 1",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },
      {
        img: img2,
        title: "Feature 2",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },

      {
        img: img2,
        title: "Feature 3",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },

      {
        img: img2,
        title: "Feature 4",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },
    ],

    use_case: [
      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },
      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },

      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },

      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },
    ],

    marketing: [
      {
        img: img,
        title: "Event Registration 1",
        description1:
          "Automatically register participants via WhatsApp for your events based on chatbot-initiated interactions. ",
        background: "#e1efff",
      },
      {
        img: img,
        title: "Event Registration 2",
        description1:
          "Track real-time analytics and registrations using WhatsApp-based campaign systems tailored to your needs.",
        background: "#EAFBF1",
      },

      {
        img: img,
        title: "Event Registration 3",
        description1:
          "Gather payments for your event registrations directly via WhatsApp integrated payment gateways.",
        background: "#e2e9f0",
      },

      {
        img: img,
        title: "Event Registration 4",
        description1:
          "Send smart reminders and follow-ups to incomplete registrations to boost participation.",
        background: "#e3e9ff",
      },
    ],
  },

  {
    card_id: "12",
    introduction: {
      img: img,
      title:
        "12Unlock digital success for your business with all-in-one SaaS solution!",
      description:
        "12Seamlessly integrate with multiple apps and maximize your brand's digital potential. Drive data-driven growth and achieve unparalleled success with Vertex Suite.",
    },

    features: [
      {
        img: img2,
        title: "Test Feature 1",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },
      {
        img: img2,
        title: "Feature 2",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },

      {
        img: img2,
        title: "Feature 3",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },

      {
        img: img2,
        title: "Feature 4",
        description1: "Track your campaign results in real-time.",
        description2:
          "Monitor Read, Replied & Clicked rates for each campaign and retarget smartly for higher conversions!",
      },
    ],

    use_case: [
      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },
      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },

      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },

      {
        img: img,
        title: "Run Ads that Click to WhatsApp",
        description1:
          "Run Ads on Facebook & Instagram that land on WhatsApp. 5X Your lead generations & 2-3X Conversions Instantly!",
        description2:
          "Run Ads from cdddssfs, smartly segregate your leads and build Chatbot Flows to automate everything!",
      },
    ],

    marketing: [
      {
        img: img,
        title: "Event Registration 1",
        description1:
          "Automatically register participants via WhatsApp for your events based on chatbot-initiated interactions. ",
        background: "#e1efff",
      },
      {
        img: img,
        title: "Event Registration 2",
        description1:
          "Track real-time analytics and registrations using WhatsApp-based campaign systems tailored to your needs.",
        background: "#EAFBF1",
      },

      {
        img: img,
        title: "Event Registration 3",
        description1:
          "Gather payments for your event registrations directly via WhatsApp integrated payment gateways.",
        background: "#e2e9f0",
      },

      {
        img: img,
        title: "Event Registration 4",
        description1:
          "Send smart reminders and follow-ups to incomplete registrations to boost participation.",
        background: "#e3e9ff",
      },
    ],
  },
];

export default data;
